var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMenuDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tjk4hgksva"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1423",
    style: {
      fill: "none"
    },
    d: "M0 0h116v116H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1659"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1422",
    style: {
      fill: "#c6c6c6"
    },
    d: "M0 0h116v116H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 256",
    d: "M490.542 400.867h3.49v-11.3h-3.49v4.24h-3.818v-4.24h-3.49v11.3h3.49v-4.24h3.818z",
    transform: "translate(-429.534 -346.279)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1658"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1657",
    style: {
      clipPath: "url(#tjk4hgksva)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 257",
    d: "M595.452 406.969v.649a3.3 3.3 0 0 0-2.372-.919c-2.382 0-4.179 2.277-4.179 4.825 0 2.751 1.632 4.825 4.089 4.825a3.2 3.2 0 0 0 2.462-.919v.657h3.32v-9.118zm-.058 4.555a1.823 1.823 0 0 1-1.641 1.96 1.992 1.992 0 0 1-.024-3.921 1.813 1.813 0 0 1 1.664 1.96",
    transform: "translate(-523.458 -361.505)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 258",
    d: "M688.653 406.969v11.537h3.32v-3.076a3.319 3.319 0 0 0 2.5.919c2.148 0 4.051-2.074 4.051-4.825 0-2.548-1.759-4.825-4.141-4.825a3.422 3.422 0 0 0-2.41.919v-.649zm5.042 2.595a1.992 1.992 0 0 1-.023 3.921 1.989 1.989 0 0 1 .023-3.921",
    transform: "translate(-612.125 -361.505)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 259",
    d: "M784.761 406.969v11.537h3.32v-3.076a3.319 3.319 0 0 0 2.5.919c2.148 0 4.051-2.074 4.051-4.825 0-2.548-1.759-4.825-4.141-4.825a3.422 3.422 0 0 0-2.41.919v-.649zm5.042 2.595a1.992 1.992 0 0 1-.023 3.921 1.989 1.989 0 0 1 .023-3.921",
    transform: "translate(-697.553 -361.505)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 260",
    d: "m876.228 409.178-1.728 4.258-1.725-4.258h-3.464l3.52 8.488-1.455 3.513h3.414l4.9-12z",
    transform: "translate(-772.707 -363.708)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 261",
    d: "M486.238 548.76a6.032 6.032 0 1 1-6.031-5.93 5.91 5.91 0 0 1 6.031 5.93m-3.269 0a2.763 2.763 0 1 0-2.762 2.848 2.755 2.755 0 0 0 2.762-2.848",
    transform: "translate(-421.482 -482.508)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 262",
    d: "M666.613 545.443v2.819a3.465 3.465 0 0 0-2.43-.919c-2.4 0-4.176 2.277-4.176 4.825 0 2.751 1.919 4.825 4.085 4.825a3.36 3.36 0 0 0 2.521-.919v.657h3.347v-11.288zm-.058 6.725a1.828 1.828 0 0 1-1.654 1.96 1.989 1.989 0 0 1-.024-3.921 1.819 1.819 0 0 1 1.678 1.96",
    transform: "translate(-586.664 -484.83)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 263",
    d: "M598.181 563.652a2.649 2.649 0 0 0-3.617 1.671v-1.7h-3.344v9.12h3.343v-3.677c0-1.585 1.429-2.7 3.617-1.953 0-.4.007-3.248 0-3.463",
    transform: "translate(-525.52 -500.854)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 264",
    d: "M864.015 563.708a2.649 2.649 0 0 0-3.618 1.671v-1.7h-3.343v9.12h3.346v-3.678c0-1.585 1.429-2.7 3.618-1.953 0-.4.007-3.248 0-3.463",
    transform: "translate(-761.813 -500.904)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 265",
    d: "M763.1 569.647a2.014 2.014 0 0 1-1.951-1.507h6.921a4.645 4.645 0 0 0 .056-.61v-.112a4.926 4.926 0 0 0-5.015-4.814c-.151 0-.3.007-.446.019a4.9 4.9 0 0 0-4.594 4.8v.13a4.906 4.906 0 0 0 4.5 4.667h.076c.152.012.305.019.461.02a5 5 0 0 0 4.8-3.416h-3.19a1.977 1.977 0 0 1-1.618.823m0-4.428a2.038 2.038 0 0 1 1.738 1h-3.478a2.039 2.039 0 0 1 1.738-1",
    transform: "translate(-673.829 -500.083)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 266",
    d: "M109.79 377.162h-7.922a1.481 1.481 0 0 1-.269-.026 1.529 1.529 0 0 1-1.182-1.488v-3.917a1.378 1.378 0 0 0-1.139-1.356 1.4 1.4 0 0 0-.317-.038h-8.2a1.378 1.378 0 0 0-1.378 1.378v3.917a1.53 1.53 0 0 1-1.529 1.529h-7.843a1.809 1.809 0 0 0-1.809 1.809v5.122a1.809 1.809 0 0 0 1.809 1.809H89.7v.016h20.09a1.809 1.809 0 0 0 1.809-1.809v-5.138a1.809 1.809 0 0 0-1.809-1.809m1.977-18.972c.014-.261.023-.524.023-.795a11.652 11.652 0 0 0-1.014-4.982 7.712 7.712 0 0 0-2.875-3.351 7.808 7.808 0 0 0-4.265-1.177H86.165a7.81 7.81 0 0 0-4.265 1.177 7.717 7.717 0 0 0-2.874 3.351 12.739 12.739 0 0 0 0 9.963 7.709 7.709 0 0 0 2.874 3.351 7.8 7.8 0 0 0 4.264 1.177h17.77a8.02 8.02 0 0 0 2.751-.552 7.902 7.902 0 0 0 .743-.345c.161-.085.318-.178.474-.276a7.389 7.389 0 0 0 .935-.7 7.984 7.984 0 0 0 1.94-2.647 10.578 10.578 0 0 0 .833-2.743 13.832 13.832 0 0 0 .161-1.442zm-22.808 1.371a2.027 2.027 0 0 1-1.045-.268 1.8 1.8 0 0 1-.7-.763 2.714 2.714 0 0 1 0-2.268 1.8 1.8 0 0 1 .7-.763 2.02 2.02 0 0 1 1.045-.268h11.878a2.008 2.008 0 0 1 1 .268 1.8 1.8 0 0 1 .7.763 2.714 2.714 0 0 1 0 2.268 1.79 1.79 0 0 1-.7.763 2.02 2.02 0 0 1-1.045.268H88.959z",
    transform: "translate(-69.342 -309.227)",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuDefault);
export default __webpack_public_path__ + "static/media/ic-menu-default.48bad7452350c440a9865109db7dddf9.svg";
export { ForwardRef as ReactComponent };